import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

export function trackEvent(name: string, params?: Record<string, string | number | boolean>) {
  if (!analytics) return;
  try {
    logEvent(analytics, name, params);
  } catch {
    // Silently ignore analytics failures
  }
}

export function trackPageView(page: string) {
  trackEvent('page_view', { page_path: page });
}
